export default "assets/images/logo-9014eeab.png";